module.exports = __webpack_public_path__ + "static/iwmf.96c5f5dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/iwmf.png
// module id = 764
// module chunks = 114276838955818